import { render, staticRenderFns } from "./WorkItemChange.vue?vue&type=template&id=4011c230&scoped=true&"
import script from "./WorkItemChange.vue?vue&type=script&lang=js&"
export * from "./WorkItemChange.vue?vue&type=script&lang=js&"
import style0 from "./WorkItemChange.vue?vue&type=style&index=0&id=4011c230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011c230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VIcon,VRow,VSheet})
